/**
 * @license Highcharts JS v12.2.0 (2025-04-07)
 * @module highcharts/modules/sankey
 * @requires highcharts
 *
 * Sankey diagram module
 *
 * (c) 2010-2025 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */
'use strict';
import Highcharts from '../../Core/Globals.js';
import '../../Series/Sankey/SankeySeries.js';
export default Highcharts;
